import { createGlobalStyle } from "styled-components";
import { COLORS, FONT_WEIGHT, FONTS } from "../../constants/Styles";
import { HAMBURGER_PX } from "../Header/HeaderStyles";

export type GlobalStyleProps = {
  background?: string;
  hamburgerBackground?: string;
};

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html {
      background: ${COLORS.background};
  }
  body {
    font-optical-sizing: auto;
    font-style: normal;
    background: ${({ background }) => background || COLORS.background};
    box-sizing: border-box;
    font-family: ${FONTS.body};
    font-weight: ${FONT_WEIGHT.weight500};
    color: ${COLORS.secondary};
    @media (max-width: ${HAMBURGER_PX}) {
      background: ${({ hamburgerBackground, background }) =>
        hamburgerBackground || background || COLORS.background};
    }
  }
  a {
    color: ${COLORS.primary};
  }
  a:hover { color:${COLORS.primary}; }
  input, select, textarea {
    color-scheme: dark;
    color: ${COLORS.secondaryLight};
    border-style: solid;
    border-color: transparent;
    border-width: 1px;
    border-radius: 2px;
    padding: 0.25rem;
    font-weight: ${FONT_WEIGHT.weight400};
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      opacity: 1; /* Firefox */
       color: ${COLORS.secondaryLight};
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: ${COLORS.secondaryLight};
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
      color: ${COLORS.secondaryLight};
    }
  }
  fieldset {
    border: none;
  }
  table {
    border-collapse: collapse;
  }
  th {
    text-align: left;
  }
  #__next {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  [class*='react-tooltip__place-top'] > .arrow {
      transform: rotate(45deg);
  }

  [class*='react-tooltip__place-right'] > .arrow {
      transform: rotate(135deg);
  }

  [class*='react-tooltip__place-bottom'] > .arrow {
      transform: rotate(225deg);
  }

  [class*='react-tooltip__place-left'] > .arrow {
      transform: rotate(315deg);
  }
   .grecaptcha-badge {
       display: none !important;
   }
    .react-datepicker-popper {
        z-index: 10;
    }
   .react-datepicker {
       border-radius: 1rem;
       background-color: ${COLORS.inputGray};
       color: ${COLORS.secondary};
       padding: 1rem;
       width: 100%;
   }
   .react-datepicker__triangle {
       color: ${COLORS.tableBackground};
   }
   .react-datepicker__aria-live {
       display: none;
   }
  .react-datepicker__day-names{
      display: flex;
      justify-content: space-between;
  }
  .react-datepicker__week{
      display: flex;
      justify-content: space-between;
      gap: 0.5rem;
  }
  .react-datepicker__day--selected {
      border: none;
  }
  .react-datepicker__month {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
  }
`;

export default GlobalStyle;
